
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../../api/axiosInstance";
const ExecuteCanvasUsers = () => {
  const navigate = useNavigate();
  const [disableExecute, setDisableExecute] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const [executeCanvasUsers, setExecuteCanvasUsers] = useState([]);
  const [schools, setSchools] = useState([]);
  const [isExecuted, setIsExecuted] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState(0);
  // On file select (from the pop up)
  const onFileChange = (index, event, schoolId) => {
    if (selectedFile[index] != undefined) {
      selectedFile[index][1] = event.target.files[0];
      executeCanvasUsers[index][1] = 0;
    } else {
      selectedFile[index] = "";
      selectedFile[index] = [event.target.files[0]];
      executeCanvasUsers[index] = [0];
    }
    setSelectedFile(selectedFile);
    setExecuteCanvasUsers(executeCanvasUsers);
  };

  // On file upload (click the upload button)
  const onFileUpload = () => {
    setIsExecuted(false);
    if (selectedFile.length == 0) {
      toast.error("Choose a file before you execute");
      return;
    }
    setTimeout(() => {
      setIsExecuted(true);
    }, 100);

    selectedFile.forEach((element, index) => {
      setTimeout(() => {
        if (element.length > 1) {
          element.forEach((e, i) => {
            setTimeout(() => {
              uploadFile(e, index, i);
            }, 1000);
          });
        } else {
          uploadFile(element[0], (index));
        }
      }, 1000);
    });
  };

  const uploadFile = (file, fIndex, sIndex) => {
    setIsExecuted(false);
    // Create an object of formData
    const formData = new FormData();

    if (sIndex == undefined) {
      executeCanvasUsers[fIndex] = [0];

      // Update the formData object
      formData.append(
        "file",
        file);
    } else {
      executeCanvasUsers[fIndex][sIndex] = [0];
      // Update the formData object
      formData.append(
        "file",
        file);
    }

    // Request made to the backend api
    // Send formData object
    var config = {
      method: "post",
      url: process.env.REACT_APP_API_URL + "File/FileUpload",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      if (response.status === 200) {
        setIsExecuted(true);
        ExecuteCanvasUsers(response.data, fIndex, sIndex);
      }
    });
  };

  const ExecuteCanvasUsers = (excelName, fIndex, sIndex) => {

    setIsExecuted(false);
    if (sIndex == undefined) {
      executeCanvasUsers[fIndex] = [2];
    } else {
      executeCanvasUsers[fIndex][sIndex] = [2];
    }
    setIsExecuted(true);
    var config = {
      method: "post",
      url:
        process.env.REACT_APP_API_URL +
        "CanvasUsers/ExecuteCanvasUsers/" +
        excelName +
        "/School/" +
        (fIndex + 1),
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config)
      .then(function (response) {
        setIsExecuted(false);
        if (response.data.statusCode === 200) {
          
          if (sIndex == undefined) {
            executeCanvasUsers[fIndex] = [3];
          } else {
            executeCanvasUsers[fIndex][sIndex] = [3];
          }
          toast.success("Executed");
        } else {
          if (sIndex == undefined) {
            executeCanvasUsers[fIndex] = [4];
          } else {
            executeCanvasUsers[fIndex][sIndex] = [4];
          }
          toast.error(response.data.message);
        }
        setTimeout(() => {
          setIsExecuted(true);
        }, 100);

      })
      .catch(function (error) {
        if (sIndex == undefined) {
          executeCanvasUsers[fIndex] = [4];
        } else {
          executeCanvasUsers[fIndex][sIndex] = [4];
        }
        if (error.response.status === 401) {
          localStorage.clear();
          navigate("/login");
          window.location.reload();
        }
      });
  };
  const getSchools = () => {
    var config = {
      method: "Get",
      url: process.env.REACT_APP_API_URL + "Schools/GetSchools/",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          setSchools(response.data.content);
        }
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          window.location = "/Login";
          window.location.reload();
        }
      });
  };

  useEffect(() => {
    if (selectedFile.length == 0) {
      getSchools();
    }
  }, [isExecuted]);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card mt-5">
              <div className="card-header">
                <h3 className="card-title">
                  Upload Excel - User Provisioning.csv
                </h3>
                <div className="align-self-center">
                  <Link
                    to={"/Settings"}
                    className="btn btn-sm btn-secondary mr-5 cts-btn-secondary"
                  >
                    Cancel
                  </Link>
                  <button
                    className="btn btn-sm btn-primary cts-btn-primary"
                    onClick={() => onFileUpload()}
                    disabled={disableExecute}
                  >
                    Execute
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-md-4">
                        <h5>School Name</h5>
                      </div>
                      <div className="col-md-8">
                        <h5>Excel Sheet/s</h5>
                      </div>
                      <div className="col-md-12">
                        <hr></hr>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="row">
                      <div className="col-md-12">
                        <h5>Status</h5>
                      </div>
                      <div className="col-md-12">
                        <hr></hr>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    {schools.map((s, index) => (
                      <>
                        <div className="row">
                          <div className="col-md-4 center-middle-div">
                            <h6>
                              {s.schoolId}. {s.schoolName}
                            </h6>
                          </div>
                          <div className="col-md-4">
                            {s.schoolId == 1 ||
                            s.schoolId == 2 ||
                            s.schoolId == 3
                              ? "HS - User Provisioning"
                              : "User Provisioning"}
                            <input
                              type="file"
                              className="dropzone custom-file-input"
                              onChange={(e) => onFileChange(index, e, s.schoolId)}
                            />
                          </div>

                          <div className="col-md-4">
                            {s.schoolId == 1 ||
                            s.schoolId == 2 ||
                            s.schoolId == 3 ||
                            s.schoolId == 7 ||
                            s.schoolId == 8 ||
                            s.schoolId == 9 ? (
                              <>
                                MS - User Provisioning
                                <input
                                  type="file"
                                  className="dropzone custom-file-input"
                                  onChange={(e) => onFileChange(index, e, s.schoolId)}
                                />{" "}
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="col-md-12">
                            <hr></hr>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                  <div className="col-md-4">
                    <div className="row">
                      {isExecuted && (
                        <>
                          {schools.map((e, index) => (
                            <>
                              {executeCanvasUsers[index] != undefined ? (
                                <>
                                  <div
                                    className="col-md-6 center-middle-div"
                                    style={{ height: "54px" }}
                                  >
                                    {executeCanvasUsers[index][0] == 0 && (
                                      <div className="btn btn-primary btn-sm">
                                        Waiting
                                      </div>
                                    )}
                                    {executeCanvasUsers[index][0] == 1 && (
                                      <div className="btn btn-warning btn-sm">
                                        Uploading
                                      </div>
                                    )}
                                    {executeCanvasUsers[index][0] == 2 && (
                                      <div className="btn btn-warning btn-sm">
                                        In Progress
                                      </div>
                                    )}
                                    {executeCanvasUsers[index][0] == 3 && (
                                      <div className="btn btn-success btn-sm">
                                        Done
                                      </div>
                                    )}
                                    {executeCanvasUsers[index][0] == 4 && (
                                      <div className="btn btn-danger btn-sm">
                                        Failed
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    className="col-md-6 center-middle-div"
                                    style={{ height: "54px" }}
                                  >
                                    {executeCanvasUsers[index][1] == 0 && (
                                      <div className="btn btn-primary btn-sm">
                                        Waiting
                                      </div>
                                    )}
                                    {executeCanvasUsers[index][1] == 1 && (
                                      <div className="btn btn-warning btn-sm">
                                        Uploading
                                      </div>
                                    )}
                                    {executeCanvasUsers[index][1] == 2 && (
                                      <div className="btn btn-warning btn-sm">
                                        In Progress
                                      </div>
                                    )}
                                    {executeCanvasUsers[index][1] == 3 && (
                                      <div className="btn btn-success btn-sm">
                                        Done
                                      </div>
                                    )}
                                    {executeCanvasUsers[index][1] == 4 && (
                                      <div className="btn btn-danger btn-sm">
                                        Failed
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-12">
                                    <hr></hr>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div
                                    className="col-md-12 center-middle-div"
                                    style={{ height: "54px" }}
                                  >
                                    <div className="btn btn-danger btn-sm">
                                      No Files Uploaded
                                    </div>
                                  </div>
                                  <div className="col-md-12">
                                    <hr></hr>
                                  </div>
                                </>
                              )}
                            </>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExecuteCanvasUsers;
